import { Navbar } from "@/components/Navbar";
import { Footer, FloatingBrand } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";

export const PageLayout = ({ children, testId }) => (
  <div data-testid={testId} className="min-h-screen bg-[#0A0A0A] flex flex-col">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <CartDrawer />
    <FloatingBrand />
  </div>
);
